import * as Yup from "yup";
import React from "react";
import FormInput from "../FormInput";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import {css} from "glamor";
import Utils from "../../common/Utils";
import Icon from 'react-icons-kit';
import {ic_more_vert} from 'react-icons-kit/md/ic_more_vert';

const baseStyle = {
    borderRadius: 4,
    backgroundColor:"#ffffff",
    boxShadow: '0 2px 2px 1px #c5c5c5',
    border: 'solid 2px #ffffff0d',
    padding: 10,
    cursor: "pointer",
    '&:hover':{
        backgroundColor: "#f6f6f6"
    }
};

const walletStyle = css(baseStyle);

const defaultWalletStyle = css({
    ...baseStyle,
    borderColor: "#32b9ff"
});

const disabledStyle = css({
    ...baseStyle,
    backgroundColor:"#e2e2e2",
    borderColor: "#b9b9b9",
});

const WalletAccountTypes = [
    { text: "Subscriber" , value: "subscriber" },
    { text: "Merchant" , value: "merchant" }
];

const createNetworkWalletProvider = ({ provider, name , logo , validation , hints }) => ({
    provider,
    name,
    logo,
    validationSchema: {
        type: Yup.string().required().label("Account Type"),
        value: Yup.string().required().label("Subscription Number")
    },

    initialValues: {
        type: "subscriber",
        value: ""
    },

    customValidation: (values) => {

        let errors = {};

        switch (values.type) {

            case "subscriber":

                if(!Utils.validatePhoneNumber(values.value))
                    errors.value = 'Invalid number';

                break;
            case "merchant":

                if(validation.validate){
                    const error = validation.validate(values.value);
                    if(error){
                        errors.value = 'Invalid merchant number';
                    }
                }
                else {

                    //  validate as a raw phone number
                    if(!Utils.validatePhoneNumber(values.value))
                        errors.value = 'Invalid merchant number';
                }

                break;
        }


        return errors;
    },

    getMeta: ({ type }) => ({
        type
    }),

    walletItemRender: (wallet,{ logo , actions }) => {

        return <div className={`${wallet.enabled ? (wallet.is_default ? defaultWalletStyle : walletStyle) : disabledStyle }`}>

            <div style={{
                backgroundImage: `url(${logo})`,
                height: 64,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "50% 50%"
            }}>


            </div>

            <hr/>

            <div className="clearfix">

                <p style={{ fontSize: 'larger' , color: 'rgb(111, 111, 111)' , margin: 0 }} className="pull-left">{wallet.name}</p>

                <div className="pull-right">

                    {(!wallet.is_default || !wallet.enabled) && <UncontrolledDropdown size={"sm"}>
                        <DropdownToggle style={{ width: 2 , marginTop: -8 }} color={"link"}><Icon icon={ic_more_vert}/></DropdownToggle>
                        <DropdownMenu right>

                            {!wallet.is_default && wallet.enabled  && <DropdownItem onClick={async () => {

                                if(window.confirm(`Are you sure you make selected wallet (${wallet.name}) default?`)){
                                    return  actions.setDefault();
                                }

                            }}><i className="fa fa-check" style={{ color: "green" }}/> Set Default</DropdownItem>}

                            {!wallet.enabled && <DropdownItem onClick={async () => {

                                if(window.confirm(`Are you sure you enable the wallet (${wallet.name}) ?`)){
                                    return  actions.enable();
                                }

                            }}><i className="fa fa-bolt" style={{ color: "green" }}/> Enable</DropdownItem>}

                            {wallet.enabled && !wallet.is_default && <DropdownItem onClick={async () => {

                                if(window.confirm(`Are you sure you disable the wallet (${wallet.name}) ?`)){
                                    return  actions.disable();
                                }

                            }}><i className="fa fa-close" style={{ color: "red" }}/> Disable</DropdownItem>}
                        </DropdownMenu>
                    </UncontrolledDropdown>}
                </div>

            </div>
            <span><b>Type:</b> {WalletAccountTypes.find(x => x.value === wallet.meta.type).text}</span><br/>
            <span><b>Mobile:</b> {wallet.value}</span>

        </div>

    },

    component: ({ values }) => {

        const getTypeHint = () => {

            switch (values.type) {
                case "subscriber":
                    return `Enter subscriber wallet no. in the format eg. ${hints.subscriber}`;
                case "merchant":
                    return `Enter subscriber wallet no. in the format eg. ${hints.merchant}`;
            }

        };

        return <React.Fragment>

            <FormInput name="type"
                       title={"Wallet Account Type"}
                       type={"select"}
                       required
                       showPrompt
                       items={WalletAccountTypes}/>

            <FormInput name="value"
                       title={"Mobile No."}
                       icon={"fa fa-phone"}
                       placeholder={getTypeHint()}
                       required
                       showPrompt
                       type={"text"}/>

        </React.Fragment>
    }
})

const Providers = [];

export default Providers;



// WEBPACK FOOTER //
// ./src/components/WalletManagement/Providers.js